import * as React from 'react';
import { connect } from 'react-redux';

import ManageProfileRouter from './ManageProfileRouter';
import * as Action from '../../../actions/userDropdown.actions';

interface IManageProfieProps {
    userDropdownHide: () => void;
}

class ManageProfile extends React.Component<IManageProfieProps, null> {
    componentDidMount() {
        this.props.userDropdownHide();
    }

    render() {
        return (
            <React.Fragment>
                <ManageProfileRouter />
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    userDropdownHide: () => {
        dispatch(Action.userDropdownHide());
    }
});

export default connect(null, mapDispatchToProps)(ManageProfile);
